import { logError } from '@/src/utils/logError'

export interface RecentFSearch {
    adults: number
    childs: number
    class: string
    depart_date: string
    destination: string
    destinationCountry: string
    from: string
    infants: number
    intl: string
    origin: string
    return_date: string
    rnd_one: string
    sd: number
    sourceCountry: string
    to: string
    airline?: string
}

interface RecentSearchStorage {
    en: RecentFSearch[]
    ar: RecentFSearch[]
}

/**
 * Update home search history in localStorage
 * @param obj - The search object to save
 */
export function updateHomeSearch(obj: RecentFSearch): void {
    try {
        if (typeof window === 'undefined') {
            return
        }

        const isRtl = process.env.CONTENT_DIR === 'RTL'
        const storageName = 'fsHistory'
        const dataForm: RecentSearchStorage = { en: [], ar: [] }
        const recentSearch: RecentSearchStorage = 
            JSON.parse(localStorage.getItem(storageName) || 'null') || dataForm
        const lang = isRtl ? 'ar' : 'en'
        
        let eleFound = false
        
        // Check if this exact search already exists
        if (recentSearch[lang].length) {
            for (let i = 0; i < recentSearch[lang].length; i++) {
                const existing = recentSearch[lang][i]
                if (
                    existing.from === obj.from &&
                    existing.to === obj.to &&
                    existing.adults === obj.adults &&
                    existing.class === obj.class &&
                    existing.depart_date === obj.depart_date &&
                    existing.return_date === obj.return_date &&
                    existing.airline === obj.airline
                ) {
                    eleFound = true
                    break
                }
            }
        }
        
        // Add new search if not found
        if (!eleFound) {
            recentSearch[lang].unshift({ ...obj })
        }
        
        // Limit to maximum 3 recent searches
        if (recentSearch[lang].length > 3) {
            recentSearch[lang].length = 3
        }

        localStorage.setItem(storageName, JSON.stringify(recentSearch))
    } catch (e) {
        logError('updateHomeSearch localStorage Error', e)
    }
}

/**
 * Get flights search history from localStorage
 * @returns Array of recent flight searches
 */
export function getflightsHistory(): RecentFSearch[] {
    try {
        if (typeof window === 'undefined') {
            return []
        }

        const isRtl = process.env.CONTENT_DIR === 'RTL'
        const storageName = 'fsHistory'
        const dataForm: RecentSearchStorage = { en: [], ar: [] }
        const lang = isRtl ? 'ar' : 'en'
        
        const storedData = localStorage.getItem(storageName)
        const recentSearch: RecentSearchStorage = 
            JSON.parse(storedData || 'null') || dataForm
        
        return recentSearch[lang] || []
    } catch (e) {
        logError('getflightsHistory localStorage Error', e)
        return []
    }
}

/**
 * Clear all recent search history from localStorage
 */
export function clearRecentSearchHistory(): void {
    try {
        if (typeof window === 'undefined') {
            return
        }

        const storageName = 'fsHistory'
        localStorage.removeItem(storageName)
    } catch (e) {
        logError('clearRecentSearchHistory localStorage Error', e)
    }
}

